import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts/GlobalContext";
import { Box } from "@chakra-ui/react";
import { useContext, useEffect, useRef } from "react";
import { ViewJob } from "@/components/cortex";
import { ApplyButtonWrapper } from "./ApplyButtonWrapper";
import { SearchResultsJobDetailsHeader } from "./SearchResultsJobDetailsHeader";
var JobDetailsContent = function (_a) {
    var job = _a.job, lastTrackedJobKey = _a.lastTrackedJobKey;
    var properties = useContext(GlobalContext).properties;
    useEffect(function () {
        if (window.utl && job.jobKey !== lastTrackedJobKey.current) {
            var trackingKey = properties.placementId
                ? "".concat(job.jobKey, "-").concat(properties.placementId)
                : job.jobKey;
            window.utl.recordJobDataResultsShown([trackingKey]);
            lastTrackedJobKey.current = job.jobKey;
        }
    }, [job.jobKey, properties.placementId, lastTrackedJobKey]);
    return (_jsx(ViewJob, { jobTitle: job.title, header: _jsx(SearchResultsJobDetailsHeader, { job: job }), body: _jsx(Box, { dangerouslySetInnerHTML: { __html: job.description } }), footer: _jsx(ApplyButtonWrapper, { job: job, variant: "searchResultsDetailsFooter" }) }));
};
export var SearchResultsJobDetails = function (_a) {
    var jobs = _a.jobs, selectedJobKey = _a.selectedJobKey;
    var job = jobs.find(function (job) { return job.jobKey === selectedJobKey; });
    var lastTrackedJobKey = useRef(undefined);
    if (!job) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(JobDetailsContent, { job: job, lastTrackedJobKey: lastTrackedJobKey }, job.jobKey));
};
